{
  "submit": "Validate",
  "loading": "Loading...",
  "add-column": {
    "add-button": "Add a column",
    "briefing": "Generate my briefing ✨",
    "search-title": "Search",
    "topic-title": "Sections"
  },
  "onboarding": {
    "templates": {
      "title": "Add your first columns",
      "subtitle": "Pick the columns you want to add to your deck. You can edit or add more at any time.",
      "recommended": "Recommended",
      "topics": "Sections",
      "submit": "Create {count} column | Create {count} column | Create {count} columns",
      "submit-empty": "Select at least one column",
      "skip": "Later",
      "close": "Close",
      "reopen": "Discover recommended columns",
      "defaults": {
        "all-news": {
          "label": "All content (no photos)",
          "description": "The full AFP feed in your language, excluding photos."
        },
        "topshot": {
          "label": "Topshot",
          "description": "Hand-picked selection of AFP's best photos."
        }
      }
    },
    "nudges": {
      "add-column": {
        "text": "You only have one column. Add a second one to follow multiple topics side by side.",
        "cta": "Add a column"
      },
      "ai-discovery": {
        "text": "You have access to Deck AI ✨ — let it guide you in 30 seconds.",
        "cta": "Discover AI"
      },
      "mobile-install": {
        "text": "Install Deck on your home screen for quick access, even offline.",
        "cta": "Install"
      },
      "desktop-cross": {
        "text": "Deck also follows you on mobile: your columns stay synced across devices.",
        "cta": "See how"
      },
      "mobile-cross": {
        "text": "You're using Deck on mobile — open it on your computer too, your columns will already be there.",
        "cta": "See how"
      },
      "dismiss": "Dismiss"
    },
    "cross-device": {
      "title": "Open Deck on your phone",
      "description": "Scan this QR code with your mobile. Your columns stay synced across all devices.",
      "title-mobile": "Open Deck on your computer",
      "description-mobile": "Send yourself the link or copy it to paste into your desktop browser. Your columns will already be synced.",
      "qr-alt": "QR code to the Deck app",
      "copy": "Copy link",
      "copied": "Copied!",
      "share": "Share",
      "close": "Close"
    },
    "tour": {
      "start": "Guided tour",
      "next": "Next",
      "prev": "Previous",
      "done": "Done",
      "skip": "Skip",
      "progress": "Step {current} of {total}",
      "steps": {
        "welcome": {
          "title": "Welcome to Deck",
          "description": "Take this tour to discover the main features in less than a minute."
        },
        "omnibox": {
          "title": "Search & navigation",
          "description": "Type here to open a section, run an AFP search or ask the AI."
        },
        "column": {
          "title": "Columns",
          "description": "Each column tracks a topic in real time. Add as many as you like and reorder them via drag-and-drop."
        },
        "theme": {
          "title": "Settings",
          "description": "In the account menu: light/dark theme, assistant voice, language, and more."
        },
        "voice": {
          "title": "Voice assistant",
          "description": "Tap to talk: ask your questions out loud and the AI answers by voice — hands-free."
        },
        "ai": {
          "title": "Deck AI",
          "description": "Get a briefing, fact-check a claim, analyse an article — AI is plugged into every AFP feed."
        },
        "cross-device": {
          "title": "Mobile + desktop",
          "description": "Open Deck on your phone: your columns follow you automatically."
        },
        "end": {
          "title": "You're all set!",
          "description": "You can replay this tour any time from the account menu, under Help and guided tour."
        }
      }
    }
  },
  "omnibox": {
    "placeholder-ai": "Ask anything...",
    "placeholder-search": "What are you looking for?",
    "search-column": "Search",
    "ask-ai": "Ask AI",
    "open-topic": "Open section",
    "empty-column": "All content in {language}",
    "open-product": "Open {product}",
    "search-in-product": "Search “{query}” in {product}",
    "open-document": "Open document {id}",
    "open-event": "Open event {id}",
    "map-keywords": "map",
    "open-map": "Open the map",
    "search-on-map": "“{query}” on the map"
  },
  "products": {
    "text": "news",
    "multimedia": "multimedia",
    "picture": "photos",
    "graphic": "infographics",
    "videography": "videographies",
    "video": "videos",
    "webstory": "social stories",
    "factcheck": "fact checks"
  },
  "column": {
    "search": "Searching...",
    "classe": "in all content (no photos)",
    "no-result": "End of results",
    "delete": "Delete",
    "refresh": "Refresh?",
    "loading": "Loading...",
    "error": "Error during update",
    "filters": "Filters and reorder column",
    "scroll-to-top": "Scroll to top",
    "limit-reached": "Column limit of {max} reached",
    "share": "Share column",
    "link-copied": "Column link copied",
    "digest": "Column digest"
  },
  "about": {
    "name": "About",
    "title": "About Deck",
    "description": "Deck is an application developed by Jules Bonnard to view the news, photos, videos, and infographics from AFP, made available through the API. Its first version was released in May 2018.",
    "discover": "Discover Deck",
    "mobile": "On mobile: ",
    "install-mobile-app": "Install the app on your home screen",
    "open-on-mobile": "Open Deck on my phone",
    "desktop": "On computer and mobile: ",
    "desktop-app": "Visit afpdeck.app",
    "open-on-desktop": "Open Deck on my computer",
    "contact": "If you have questions or suggestions: ",
    "contact-link": "Contact the developer",
    "version": "Version"
  },
  "changelog": {
    "title": "Changelog",
    "link": "What's new"
  },
  "auth": {
    "login": "Log in",
    "logout": "Log out",
    "email": "Email",
    "password": "Password",
    "token": "Enter the code received by email",
    "toast-login": "You are logged in",
    "toast-logout": "You are logged out",
    "invalid-credentials": "The email and/or password is incorrect",
    "invalid-token": "The verification code is incorrect",
    "email-warning": "You must enter a valid professional email",
    "sync": "Sync settings",
    "sync-explanation": "Your search settings are already saved locally on your device. If you wish, you can save them to the cloud to access them on your various devices.",
    "already-synced": "Your search settings are currently synced to the session belonging to "
  },
  "classes": {
    "all": "in all content (no photos)",
    "text": "in news",
    "multimedia": "in the multimedia feed",
    "picture": "in photos",
    "graphic": "in infographics",
    "videography": "in videographies",
    "video": "in videos",
    "webstory": "in social stories",
    "livereport": "in live broadcasts",
    "factcheck": "in fact checks"
  },
  "language-name": {
    "en": "English",
    "fr": "French",
    "de": "German",
    "es": "Spanish",
    "pt": "Portuguese"
  },
  "languages": {
    "all": "in all languages",
    "en": "in English",
    "fr": "in French",
    "de": "in German",
    "es": "in Spanish",
    "pt": "in Portuguese",
    "ar": "in Arabic"
  },
  "connectivity": {
    "messageOff": "Your device is offline",
    "messageOn": "Your device is back online"
  },
  "viewer": {
    "see-more": "See more in a column",
    "no-related": "No documents found"
  },
  "document": {
    "share": "Share",
    "copied": "Copied to clipboard",
    "read-more": "Full article:",
    "updated": "Updated",
    "published": "Published",
    "version": "version",
    "quit": "Exit",
    "copy": "Copy",
    "copy-done": "Copied",
    "copy-paragraph-link": "Copy link to this paragraph",
    "listen": "Listen",
    "correction": "Correction",
    "canceled": "Kill",
    "update": "Update",
    "subtitles": "Subtitles",
    "subtitlesOriginal": "Original subtitles",
    "chapters": "Chapters",
    "download": "Download",
    "downloadShot": "Download this shot",
    "download-preview": "Preview (with banner)",
    "download-highdef-option": "Full resolution",
    "download-error": "Download failed"
  },
  "ai": {
    "title": "AI Assistant",
    "new-conversation": "New conversation",
    "thinking": "Thinking...",
    "tool-labels": {
      "web_search": "Web search",
      "fetch_url": "Fetching page",
      "read_skill": "Reading skill",
      "save_skill": "Saving skill",
      "list_skills": "Listing skills",
      "delete_skill": "Deleting skill",
      "render_chart": "Rendering chart",
      "render_map": "Rendering map",
      "render_montage": "Preparing a montage",
      "afp_get_video_frames": "Extracting video frames"
    },
    "no-conversations": "No conversations",
    "type-message": "Write a message...",
    "send": "Send",
    "stop": "Stop",
    "delete-conversation": "Delete",
    "link": {
      "doc-unavailable": "Dispatch unavailable"
    },
    "prompts": {
      "skillsTitle": "Get started with a skill",
      "title": "What would you like to know?",
      "analyze-topic": "Analyze a topic"
    },
    "skill-editor": {
      "create": "Create",
      "create-help": "Need help? The assistant can guide you step by step to create your skill.",
      "create-help-cta": "Launch the assistant",
      "manage": "Manage my skills",
      "manage-title": "My skills",
      "list-empty": "No custom skill yet. Create one or import a .md file.",
      "back": "Back to skills",
      "back-chat": "Back to chat",
      "reorder": "Drag to reorder",
      "arguments-hint": "Tip: use $ARGUMENTS in the instructions to make the skill parameterizable (e.g. /briefing automotive).",
      "create-title": "Create a skill",
      "edit-title": "Edit skill",
      "import": "Import a file",
      "imported": "Skill imported",
      "created": "Skill \"{name}\" created",
      "updated": "Skill \"{name}\" updated",
      "deleted": "Skill \"{name}\" deleted",
      "delete": "Delete",
      "delete-confirm": "Delete the skill \"{name}\"?",
      "name": "Name",
      "name-placeholder": "Sports analysis",
      "id": "Identifier",
      "icon": "Icon",
      "type": "Type",
      "type-general": "General",
      "type-contextual": "Contextual",
      "type-general-hint": "Shown on the chat home page.",
      "type-contextual-hint": "Available from a story's AI menu.",
      "document-types": "Content types",
      "document-types-hint": "None selected = applies to all content.",
      "order": "Display order",
      "content": "Instructions",
      "content-placeholder": "# Skill title\n\nInstructions for the assistant...",
      "cancel": "Cancel",
      "save": "Save",
      "errors": {
        "id-required": "The identifier is required.",
        "id-format": "The identifier must use lowercase letters, digits and hyphens only.",
        "id-reserved": "This identifier is reserved for a built-in skill.",
        "id-exists": "A skill with this identifier already exists.",
        "content-required": "Instructions are required."
      }
    },
    "disclaimer": "AI can make mistakes. Please verify by reading the original articles.",
    "print": "Print",
    "tokens": "{count} tokens",
    "approve": "Approve",
    "reject": "Reject",
    "approved": "Approved",
    "rejected": "Rejected",
    "error-generation": "Error during generation",
    "error-disconnect": "Connection lost with server",
    "error-empty-response": "The assistant did not generate a response",
    "error-budget": "The monthly AI budget has been reached. The assistant is temporarily unavailable.",
    "error-rate-limit": "Too many requests. Please try again in a few moments.",
    "error-model-not-found": "The selected model is no longer available. Reload the page or pick another one.",
    "compact": "Compact context",
    "compact-done": "Context compacted",
    "rewind": "Rewind to this point",
    "rewind-done": "Conversation rewound to this point",
    "chart-export": "Export chart",
    "chart-export-failed": "Chart export failed",
    "chart-series": "Series",
    "chart-label": "Label",
    "chart-value": "Value",
    "chart-view-data": "View data",
    "chart-view-chart": "View chart"
  },
  "notebook": {
    "title": "Notebook",
    "search": "Search…",
    "all-types": "All types",
    "documents": "Documents",
    "excerpts": "Excerpts",
    "notes": "Notes",
    "all-languages": "All languages",
    "empty": "No items in the notebook",
    "item-removed": "Item removed from notebook",
    "document-added": "Document added to notebook",
    "document-removed": "Document removed from notebook",
    "excerpt-added": "Excerpt added to notebook",
    "add-to-notebook": "Add to notebook",
    "remove-from-notebook": "Remove from notebook",
    "type-document": "Document",
    "type-excerpt": "Excerpt",
    "type-note": "Note",
    "show-less": "Show less",
    "show-more": "Show more",
    "save-excerpt": "Notebook",
    "excerpts-and-notes": "Excerpts & Notes",
    "view-conversation": "View conversation",
    "note-saved": "Note added to notebook",
    "unavailable": "Document no longer available"
  },
  "calendar": {
    "onlyHour": "[at] HH:mm",
    "sameDay": "[today at] HH:mm",
    "nextDay": "[tomorrow at] HH:mm",
    "nextWeek": "dddd [at] HH:mm",
    "lastDay": "[yesterday at] HH:mm",
    "lastWeek": "dddd D MMMM [at] HH:mm",
    "sameElse": "dddd D MMMM YYYY [at] HH:mm"
  },
  "install-app": "Install the application",
  "providers": {
    "afp-only": "AFP",
    "others-providers": "Other providers"
  },
  "welcome": {
    "title": "Welcome to Deck",
    "text": "New interface, same spirit: Deck evolves to be smoother, more efficient. Social Stories, partner content, improved search, synchronization between devices… and still available on mobile and desktop.",
    "ai": {
      "title": "Welcome to Deck AI ✨",
      "text": "Same spirit, new superpower: Deck AI is here to sharpen your news monitoring. Talk through the news like with a colleague, launch turbocharged searches, and let Deck guide you through the flow of information. Smart suggestions, contextualized answers, columns always synced across mobile and desktop... everything you need to stay current without drowning in the stream. Ready to explore?"
    }
  },
  "pwa": {
    "offline": "App ready in offline mode",
    "reload-prompt": "New version available, click Refresh to update.",
    "reload": "Refresh",
    "close": "Close"
  },
  "errors": {
    "db-blocked": "Another tab is preventing the database from updating. Please close other Deck tabs.",
    "db-version-change": "Deck has been updated. Reloading…"
  },
  "voice": {
    "title": "Voice assistant",
    "listening": "Listening…",
    "thinking": "Thinking…",
    "speaking": "Speaking…",
    "you": "You",
    "ai": "AI",
    "restart": "Listen again",
    "mute": "Mute voice",
    "unmute": "Enable voice",
    "not-supported": "Speech recognition is not supported by your browser.",
    "error": "Speech recognition unavailable. Check microphone permission, or use Chrome or Safari (Chromium browsers such as Dia, Brave or Arc are not compatible).",
    "save-error": "Could not save the voice conversation.",
    "interrupt": "Interrupt",
    "voice": "Voice",
    "new-conversation": "New conversation"
  },
  "settings": {
    "title": "Settings",
    "appearance": {
      "title": "Appearance",
      "light": "Light",
      "dark": "Dark",
      "auto": "System"
    },
    "voice": {
      "title": "Text-to-speech",
      "local": "Use the browser voice",
      "local-hint": "Free and offline, but quality depends on your device. Turn off for the more natural AI voice.",
      "voice": "AI voice"
    },
    "web": {
      "title": "Assistant web search",
      "hint": "The assistant can complement AFP with a web search.",
      "always": "Always allow",
      "ask": "Ask each time",
      "never": "Disable"
    },
    "viewer": {
      "title": "Photo viewer",
      "auto-highdef": "Load full resolution at max zoom",
      "auto-highdef-hint": "Staying at max zoom auto-loads the full resolution image (disabled on data saver mode or a slow connection)."
    }
  },
  "map": {
    "open-column": "Open as column",
    "chat": "Analyze with AI",
    "replay": "Replay",
    "live": "Live",
    "open": "Show on map",
    "pick-date": "Pick the period",
    "all-content": "in all content",
    "window": "Period covered by the {count} most recent items",
    "datelines": "Datelines",
    "cited-places": "Places cited",
    "read-passage": "Read the passage"
  },
  "montage": {
    "clips": "shots",
    "landscape": "16:9",
    "vertical": "9:16",
    "move-up": "Move up",
    "move-down": "Move down",
    "remove": "Remove",
    "export": "Export video",
    "cancel": "Cancel",
    "credits": "Footage",
    "skipped": "Skipped",
    "no-audio": "Your browser cannot encode AAC audio: video exported without sound.",
    "unsupported": "Your browser cannot encode H.264 video.",
    "error": "Video export failed.",
    "too-long": "Montage limited to {max} minutes: remove some shots."
  },
  "nav": {
    "deck": "Deck",
    "map": "Map",
    "chat": "Chat",
    "account": "Account",
    "help": "Help and guided tour",
    "language": "Language"
  }
}
